import PropTypes from 'prop-types';

export default {
  classes: PropTypes.object,
  // propject: PropTypes.shape(propject),
  dispatch: PropTypes.func
};
